import React from 'react';
import { Link } from 'react-router-dom'; // Added for client-side routing on internal links

const Footer = () => {
  return (
    <footer>
      <div className="container footer-content">
        <div className="footer-section">
          <h3>BankSystem</h3>
          <p>Decentralized banking for everyone.</p>
        </div>
        <div className="footer-section">
          <h3>Services</h3>
          <ul>
            <li><Link to="/web3pay" className="footer-link">Payments</Link></li> {/* Changed to Link to for client-side */}
            <li><Link to="/web3cash" className="footer-link">Cash</Link></li>
            <li><Link to="/web3fx" className="footer-link">Forex</Link></li>
            <li><Link to="/web3broker" className="footer-link">Broker</Link></li>
            <li><Link to="/web3markets" className="footer-link">Markets</Link></li>
            <li><Link to="/dbank" className="footer-link">$DBANK Token</Link></li>
            <li><Link to="/moneytalks" className="footer-link">MoneyTalks</Link></li>
            <li><Link to="/web3identity" className="footer-link">Identity</Link></li> {/* Note: Dupe "News" link? Fix if meant Identity */}
          </ul>
        </div>
        <div className="footer-section">
          <h3>Platform</h3>
          <ul>
            <li><Link to="/features" className="footer-link">About</Link></li>
            <li><Link to="/ens-domain" className="footer-link">ENS Domain Setup</Link></li>
            <li><Link to="/web3identity" className="footer-link">Get Started</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Resources</h3>
          <ul>
            <li><Link to="/documentation" className="footer-link">Documentation</Link></li>
            <li><Link to="/support-community" className="footer-link">Support</Link></li>
            <li><Link to="/moneytalks" className="footer-link">Community</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Connect</h3>
          <ul>
            <li><a href="https://metamask.io/download/" className="footer-link" target="_blank" rel="noopener noreferrer">Create Wallet</a></li> {/* External, keep <a> */}
            <li><Link to="/web3broker" className="footer-link">Start Trading</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        © 2025 BankSystem. All rights reserved.
        <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
        <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
        <Link to="/cookie-policy" className="footer-link">Cookie Policy</Link>
        <a href="https://x.com/intent/post?text=Comprehensive%20financial%20services%20powered%20by%20blockchain%20technology%20and%20%24ENS%20Domains%20on%20Ethereum.&url=https%3A%2F%2Fbanksystem.co" className="share-x" target="_blank" rel="noopener noreferrer">
          Share to <i className="fab fa-x-twitter"></i>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
